import React, { createContext, useState } from "react";
import { FAKE_AUTH_STATE, isFakeAuthEnabled } from "../config/fakeAuth";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
	const [auth, setAuth] = useState(() => isFakeAuthEnabled() ? { ...FAKE_AUTH_STATE } : {});

	return (
		<AuthContext.Provider value={{ auth, setAuth }}>
			{ children }
		</AuthContext.Provider>
	);
};

export default AuthContext;
